import yup from '@/libs/yup';

const MIN_LENGTH = 2;

export default yup.object({
    first_name: yup
        .string()
        .trim()
        .min(MIN_LENGTH, 'First name should be at least ${min} characters')
        .matches(
            /^[A-Z][A-Z\s-]*$/i,
            'First name can only contain letters, hyphens, and spaces'
        ),
    last_name: yup
        .string()
        .trim()
        .min(MIN_LENGTH, 'Last name should be at least ${min} characters')
        .matches(
            /^[A-Z][A-Z\s-]*$/i,
            'First name can only contain letters, hyphens, and spaces'
        ),
    job_title: yup
        .string()
        .trim()
        .min(MIN_LENGTH, 'Job title should be at least ${min} characters'),
    email: yup.string().email(),
    phone_number: yup
        .string()
        .trim()
        .matches(
            /^\+*\(?\d{1,4}\)?[-\s\\./0-9]*$/,
            'Phone number is not valid'
        ),
    organization_name: yup.string().trim(),
    website: yup.string().url().trim(),
    self_description: yup.string(),
    industry: yup.array().of(yup.string()),
    country: yup.string().trim(),
    address: yup.object({
        address_line_1: yup.string().trim(),
        address_line_2: yup.string().trim(),
        city: yup.string().trim(),
        state: yup.string().trim(),
        zipcode: yup
            .string()
            .trim()
            .matches(/^\d{4,5}$/, {
                message: 'ZIP code is not valid'
            })
    })
});
